<template>
<div class="">

    <div class="banner">
        <p class="title container">2021，我们整装重新再出发...</p>
    </div>
    <div class="container">
        <div class="about-us row" id="aboutus">
            <div class="col-md-2">
                <svg-icon icon-class="about-us" />
            </div>
            <div class="col-md-10">
                <ul class="layui-timeline">
                    <li class="layui-timeline-item">
                        <i class="layui-icon layui-timeline-axis"></i>
                        <div class="layui-timeline-content layui-text">
                            <h3 class="layui-timeline-title">2021年1月</h3>
                            <p>{{ companyName }}正式注册成立</p>
                        </div>
                    </li>
                    <li class="layui-timeline-item">
                        <i class="layui-icon layui-timeline-axis"></i>
                        <div class="layui-timeline-content layui-text">
                            <h3 class="layui-timeline-title"></h3>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
        <div class="product" id="product">
            <div class="row">
                <div class="col-md-3 col-xs-6">
                    <svg-icon icon-class="video-stream" />
                    <h3>流媒体处理</h3>
                    <p>提供专业的技术服务与解决方案</p>
                </div>
                <div class="col-md-3 col-xs-6">
                    <svg-icon icon-class="web-site" />
                    <h3>网站建设</h3>
                    <p>建站一条龙服务/开发微信小程序</p>
                </div>
                <div class="col-md-3 col-xs-6">
                    <svg-icon icon-class="app" />
                    <h3>移动APP开发</h3>
                    <p>Ios/Android/H5移动APP开发</p>
                </div>
                <div class="col-md-3 col-xs-6">
                    <svg-icon icon-class="game" />
                    <h3>游戏开发</h3>
                    <p>H5网页小游戏开发</p>
                </div>
            </div>
        </div>
        <!-- <div class="product-case">
            <div class="row">
                <div class="col-xs-12 col-sm-4 col-md-3">
                    <div class="thumbnail">
                        <img src="~@/assets/game.png" alt="H5版休闲对战游戏" />
                        <div class="caption">
                            <h4>休闲对战游戏</h4>
                            <p>H5版网页小游戏</p>
                            <a href="http://demo.memego.com:59082/pocket/" target="_blank" class="btn btn-primary" role="button">进入Demo</a>
                        </div>
                    </div>
                </div>
                <div class="col-xs-12 col-sm-4 col-md-3">
                    <div class="thumbnail">
                        <img src="~@/assets/game2.jpg" alt="H5版休闲对战游戏" />
                        <div class="caption">
                            <h4>线上体验实体街机</h4>
                            <p>H5版视频直播游戏解决方案</p>
                            <a href="#" target="_blank" class="btn btn-primary" role="button">进入Demo</a>
                        </div>
                    </div>
                </div>
            </div>
        </div> -->
        <!-- <div class="contact-us">
        <div class="col-sm-5" id="contect-map"></div>
        <div class="col-sm-2"></div>
        <div class="col-sm-5">
          <form class="form-horizontal">
            <div class="form-group">
              <label for="inputEmail3" class="col-sm-2">Email</label>
              <div class="col-sm-10">esin.zhong@hotmail.com</div>
            </div>
          </form>
        </div>
      </div> -->
    </div>
</div>
</template>

<script>
export default {
    name: "Home",
    data() {
        return {
            companyName: "广州极有米网络科技有限公司",
        };
    },
    /*  beforeCreate() {
      window.onLoad = function () {
        var map = new AMap.Map("contect-map", {
          center: [113.32587, 23.124981],
          zoom: 15,
        });

        map.setMapStyle("amap://styles/whitesmoke");

        var marker = new AMap.Marker({
          position: new AMap.LngLat(113.32587, 23.124981),
          title: "广州极有米",
        });
        map.add(marker);
      };
      var url =
        "https://webapi.amap.com/maps?v=1.4.15&key=1f2a0ef94723f9ce4a894a3d839b46dd值&callback=onLoad";
      var jsapi = document.createElement("script");
      jsapi.charset = "utf-8";
      jsapi.src = url;
      document.head.appendChild(jsapi);
    }, */
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
.banner {
    color: #fff;
    height: 600px;
    background-color: #3bfc00;
    background-image: url(~@/assets/banner-bg.png);
    background-repeat: no-repeat;
    background-size:100% 100%;
}

@media (max-width: 768px) {
    .banner {
        height: 300px;
    }
}

.banner>.title {
    font-size: 32px;
    margin: auto;
    padding-top: 150px;
    text-align: center;
}

.about-us {
    padding: 20px;
    background-color: #eee;
    min-height: 300px;
}

.about-us p {
    padding: 10px;
    font-size: 14px;
}

.product {
    min-height: 300px;
    vertical-align: middle;
    text-align: center;
    color: #666;
    padding: 30px 10px;
}

.product-case {
    background-color: #eee;
    padding: 10px;
}

.product-case .thumbnail img {
    max-height: 150px;
}

.join-us {
    min-height: 300px;
    background-color: #eee;
}

.contact-us {
    padding: 30px 0px;
    min-height: 300px;
}

#contect-map {
    height: 200px;
}

ul,
li {
    /*做时间轴的线*/
    margin: 0;
    padding: 0;
}

.layui-timeline {
    padding-left: 5px;
}

.layui-timeline-item {
    position: relative;
    padding-bottom: 20px;
}

li {
    list-style: none;
}

.layui-timeline-item:first-child::before {
    display: block;
}

.layui-timeline-item:last-child::before {
    content: "";
    position: absolute;
    left: 5px;
    top: 0;
    z-index: 0;
    width: 0;
    height: 100%;
}

.layui-timeline-item::before {
    content: "";
    position: absolute;
    left: 5px;
    top: 0;
    z-index: 0;
    width: 1px;
    height: 100%;
}

.layui-timeline-item::before,
hr {
    background-color: #5fb878;
}

.layui-timeline-axis {
    position: absolute;
    left: -5px;
    top: 0;
    z-index: 10;
    width: 20px;
    height: 20px;
    line-height: 20px;
    background-color: #fff;
    color: #5fb878;
    border-radius: 50%;
    text-align: center;
    cursor: pointer;
}

.layui-icon {
    font-family: layui-icon !important;
    font-size: 16px;
    font-style: normal;
}

.layui-timeline-content {
    padding-left: 25px;
}

.layui-text {
    line-height: 22px;
    font-size: 14px;
    color: #666;
}

.layui-timeline-title {
    position: relative;
    margin-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/Home.vue